import React from 'react';
import { Grid } from '@mui/material';
import { ResearchExperienceField } from './ResearchExperienceField';
import { type ResearchExperienceFormProps } from './types';
import { type RenderData } from '../../types';
import { APPLICATION_TEXT } from '../../lang';
const RESEARCH_EXPERIENCE = APPLICATION_TEXT.RESEARCH_EXPERIENCE;

export const ResearchExperienceForm: React.FunctionComponent<
  ResearchExperienceFormProps
> = (props: ResearchExperienceFormProps) => {
  const {
    data: {
      pastResearchExperience,
      proposedResearchTopic,
      proposedResearchPlan,
      reasons,
      longTermCareerPlan,
      expectedContribution,
      others,
    },
    isHKPFSApplicant = false,
  } = props;

  const renderData: RenderData[] = [
    {
      label: RESEARCH_EXPERIENCE.PAST_RESEARCH_EXPERIENCE,
      value: pastResearchExperience,
    },
    {
      label: RESEARCH_EXPERIENCE.PROPOSED_RESEARCH_TOPIC,
      value: proposedResearchTopic,
    },
    {
      label: RESEARCH_EXPERIENCE.PROPOSED_RESEARCH_PLAN,
      value: proposedResearchPlan,
    },
    {
      label: RESEARCH_EXPERIENCE.REASONS,
      value: reasons,
    },
    {
      label: RESEARCH_EXPERIENCE.LONG_TERM_CAREER_PLAN,
      value: longTermCareerPlan,
    },
    {
      label: RESEARCH_EXPERIENCE.EXPECTED_CONTRIBUTION,
      value: expectedContribution,
    },
    {
      label: RESEARCH_EXPERIENCE.EXPECTED_CONTRIBUTION,
      value: expectedContribution,
    },
    {
      label: isHKPFSApplicant
        ? RESEARCH_EXPERIENCE.HKPFS_OTHERS
        : RESEARCH_EXPERIENCE.SCHOLARSHIP_OTHERS,
      value: others,
    },
  ];

  return (
    <div>
      <Grid container spacing={3} padding={'1rem'}>
        {renderData.map((data, index) => (
          <ResearchExperienceField
            key={index}
            label={data.label}
            fieldData={data.value as string}
          />
        ))}
      </Grid>
    </div>
  );
};
